module.exports = __webpack_public_path__ + "static/nanopesos-girl-a82c24f5362b16256d0f793f6a02c735.png";